'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require('./SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Collections_Footer = function (_React$Component) {
	_inherits(Collections_Footer, _React$Component);

	function Collections_Footer() {
		_classCallCheck(this, Collections_Footer);

		var _this = _possibleConstructorReturn(this, (Collections_Footer.__proto__ || Object.getPrototypeOf(Collections_Footer)).call(this));

		_this.handleResize = _this.handleResize.bind(_this);
		_this.checkSticky = _this.checkSticky.bind(_this);

		_this.state = {
			pw: '100%',
			sticky: true
		};
		return _this;
	}

	_createClass(Collections_Footer, [{
		key: 'checkSticky',
		value: function checkSticky() {

			var ipLib = document.getElementById('ip-icon-library');
			var scrollPos = window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop;
			var scrollHeight = document.documentElement.scrollHeight;

			if (scrollPos + document.documentElement.offsetHeight > ipLib.offsetHeight + ipLib.offsetTop) {
				this.setState({
					sticky: false
				});
			} else {
				this.setState({
					sticky: true
				});
			}
		}
	}, {
		key: 'handleResize',
		value: function handleResize(event) {
			var parentWidth = this.refs.libFooter.parentElement.offsetWidth;
			if (this.state.sticky) {
				this.setState({
					pw: parentWidth
				});
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.handleResize();

			window.addEventListener('resize', this.handleResize);
			window.addEventListener('scroll', this.checkSticky);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			window.removeEventListener('resize', this.handleResize);
			window.removeEventListener('scroll', this.checkSticky);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				'div',
				{ className: 'ip-collectionsFooter ' + (this.state.sticky ? 'is-sticky' : ''), style: { width: this.state.pw + 'px' }, ref: 'libFooter' },
				_react2.default.createElement(
					'div',
					{ className: 'ip-collectionsFooter-inner' },
					iconPressConfig.more_icons_url != '' && this.props.context == 'management' && _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'a',
							{ href: iconPressConfig.more_icons_url, className: 'ip-btn ip-btn--lined ip-btn--blue ip-btn-addMoreIconsUrl', target: '_blank' },
							'+ ',
							iconPressConfig.translations.ADD_MORE_ICONS
						)
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'span',
							{ className: 'ip-totalIcons' },
							_react2.default.createElement(
								'span',
								{ className: 'ip-totalIcons-highlight' },
								this.props.selected.length
							),
							iconPressConfig.translations.TOTAL_ICONS_SELECTED
						),
						_react2.default.createElement(
							'a',
							{ href: '#', className: 'ip-btn ip-btn--lined ip-btn--green ip-saveBtn', onClick: function onClick(event) {
									_this2.props.handleSave(event, false);
								} },
							_react2.default.createElement(
								'span',
								null,
								iconPressConfig.translations.SAVE
							)
						),
						_react2.default.createElement(
							'span',
							{ className: 'ip-or' },
							iconPressConfig.translations.OR
						),
						_react2.default.createElement(
							'a',
							{ href: '#', className: 'ip-btn ip-btn--lined ip-btn--black ip-saveBtn', onClick: function onClick(event) {
									_this2.props.handleSave(event, true);
								} },
							_react2.default.createElement(
								'span',
								null,
								iconPressConfig.translations.SAVE_ACCESS_YOUR_COLLECTION,
								' ',
								_react2.default.createElement(_SvgIcon2.default, { icon: 'angle-right' })
							)
						)
					)
				)
			);
		}
	}]);

	return Collections_Footer;
}(_react2.default.Component);

exports.default = Collections_Footer;


//////////////////
// WEBPACK FOOTER
// ./src/components/Collections_Footer.js
// module id = 260
// module chunks = 0 1